var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-container module" },
    [
      _c("top-bar", { attrs: { title: "Home" } }),
      _c("div", { staticClass: "container center h-full" }, [
        _vm._m(0),
        _c("div", { staticClass: "card-list" }, [
          _c("div", { staticClass: "headline" }, [
            _vm._v("Where do you want to go today?")
          ]),
          _c(
            "div",
            { staticClass: "group" },
            _vm._l(_vm.links, function(l) {
              return _c(
                "router-link",
                {
                  key: l.link,
                  staticClass: "item",
                  attrs: { to: "/" + l.link }
                },
                [
                  _c("div", { staticClass: "image no-image" }, [
                    _c("div", { staticClass: "icon" }, [
                      _c("i", { class: "icn icn-" + l.icon })
                    ])
                  ]),
                  _c("div", { staticClass: "inner" }, [
                    _c("div", { staticClass: "major" }, [
                      _vm._v(_vm._s(l.name))
                    ]),
                    _c("div", { staticClass: "description" }, [
                      _vm._v(_vm._s(l.description))
                    ]),
                    _c("div", { staticClass: "cta" }, [
                      _c("div", { staticClass: "grad" }, [
                        _vm._v("View "),
                        _c("i", {
                          staticClass: "icn icn-chevron-double-right sm"
                        })
                      ])
                    ])
                  ])
                ]
              )
            }),
            1
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "bg-header" }, [
      _c("div", { staticClass: "headline" }, [_vm._v("Welcome to PandaVue")]),
      _c("div", { staticClass: "sub-headline" }, [_vm._v("Home of WWF")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }